import { Button, FormGroup, FormLabel } from 'react-bootstrap';
import { AllStartConvoRequest } from 'cb-model';
import { fetchApi, General, makeResetCache, notifyError, notifyResponse } from 'gossamer-front-end';
import { CompoundResponse, FieldType } from 'gossamer-unified';
import { FormEvent, useState } from 'react';
import { useDispatch } from 'react-redux';

interface CreateForumConvoProps {
  forumType: string;
  forumKey: string;
  institutionId: number;
  onSent: () => void;
}

export const CreateForumConvo = (props: CreateForumConvoProps) => {
  const [subject, setSubject] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const [submitUnattempted, setSubmitUnattempted] = useState(undefined);
  const dispatch = useDispatch();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setSubmitUnattempted(false);
    if (!subject || !message) {
      return;
    }
    try {
      const payload: AllStartConvoRequest = {
        subject,
        message,
        institutionId: props.institutionId,
        toUserIds: [],
        forumType: props.forumType,
        forumKey: props.forumKey,
      };
      const resp: CompoundResponse = await fetchApi('POST', '/main/start-convo', payload);
      // reset cache
      const resetCache = makeResetCache(dispatch);
      notifyResponse(resp);
      resetCache('ConvoUserView');
      props.onSent();
    } catch (error) {
      notifyError(error, 'An error occurred while creating the conversation');
    }
  };
  return (
    <form onSubmit={handleSubmit}>
      <FormGroup id="subject">
        <FormLabel>Subject</FormLabel>
        <General
          editable={true}
          fieldId="subject"
          field={{
            seq: 5,
            type: FieldType.Text,
            label: 'Subject',
          }}
          handleChange={setSubject}
          validity={!!subject || submitUnattempted}
          value={subject}
        />
      </FormGroup>
      <br />
      <FormGroup id="message">
        <FormLabel>Message</FormLabel>
        <General
          editable={true}
          fieldId="message"
          field={{
            seq: 5,
            type: FieldType.Text,
            label: 'Message',
          }}
          handleChange={setMessage}
          validity={!!message || submitUnattempted}
          value={message}
        />
      </FormGroup>
      <br />
      <Button variant="primary" size="sm" type="submit">
        Send
      </Button>
    </form>
  );
};
